import { render, staticRenderFns } from "./r-radio-group.vue?vue&type=template&id=c106b580&"
import script from "./r-radio-group.vue?vue&type=script&lang=js&"
export * from "./r-radio-group.vue?vue&type=script&lang=js&"
import style0 from "./r-radio-group.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports